import axios, { AxiosError } from 'axios';
import { PAGE, API } from 'helpers/pages';
import StatusCode from 'status-code-enum';
import { GetServerSidePropsContext } from 'next';

const cleanApiError = (axiosError: AxiosError) => ({
  api: {
    request: {
      url: axiosError?.config?.url,
      baseURL: axiosError?.config?.baseURL,
      method: axiosError?.config?.method,
      params: axiosError?.config?.params,
      body: axiosError?.config?.data
        ? JSON.parse(axiosError?.config?.data)
        : -1,
    },
    response: {
      status: axiosError?.response?.status,
      statusText: axiosError?.response?.statusText,
      data: axiosError?.response?.data || -1,
    },
  },
});

export const logServerError = (route: PAGE | API, error: any) => {
  if (axios.isAxiosError(error)) {
    return {
      route,
      ...cleanApiError(error),
    };
  } else {
    return {
      route,
      ...error,
      message: error.message || 'Unexpected server error',
    };
  }
};

export const logError = (
  ctx: GetServerSidePropsContext,
  error: any,
  page: PAGE,
) => {
  ctx.req.log.error(logServerError(page, error));

  if (error.code === 'ECONNABORTED') {
    // Timeout
    ctx.res.statusCode = StatusCode.ServerErrorGatewayTimeout;
  } else if (error?.response?.status === StatusCode.ClientErrorBadRequest) {
    // Bad request
    ctx.res.statusCode = StatusCode.ClientErrorBadRequest;
  } else {
    // Signal that there is an error
    ctx.res.statusCode = StatusCode.ServerErrorInternal;
  }
};
